import { z } from "zod"
import { atomWithStorage, createJSONStorage } from "jotai/utils"

const storage = createJSONStorage<PeriodFormData>(() => localStorage)

const currYear = new Date().getUTCFullYear() - 1
export const defaultPeriod: PeriodFormData = {
	range: [`${currYear}-01-01`, `${currYear}-12-31`],
	isCustomDate: false,
}
export const periodDraftAtom = atomWithStorage<PeriodFormData>(
	"miles:draft:period",
	defaultPeriod,
	storage,
	{ getOnInit: true }
)

export const periodFormSchema = z.object({
	range: z.tuple([z.string(), z.string()]),
	isCustomDate: z.boolean(),
})

export type PeriodFormData = z.infer<typeof periodFormSchema>

export type PeriodFormDataOptionalRange = Omit<PeriodFormData, "range"> & {
	range: [string | undefined, string | undefined]
}
